import React from "react";

export function Check() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4.5383 11.9999C4.16527 11.9999 3.81247 11.8254 3.58567 11.5261L0.522583 7.48089C0.124183 6.95477 0.227898 6.20563 0.754012 5.80706C1.28098 5.40832 2.02961 5.51272 2.42818 6.03849L4.44281 8.69872L9.50973 0.563059C9.85858 0.00334478 10.5952 -0.167912 11.1561 0.180431C11.7164 0.529116 11.8874 1.26626 11.5384 1.82649L5.55281 11.4368C5.34487 11.7709 4.9859 11.9811 4.59281 11.9989C4.57447 11.9996 4.55647 11.9999 4.5383 11.9999Z"></path>
    </svg>
  );
}
